import React from "react";
import "./BlogActionModal.css";

const BlogActionModal = ({ onClose, onApprove, onReject, blogTitle }) => {
  return (
    // <div className="modal-overlay">
    //   <div className="modal">
    //     <button className="modal-close-icon" onClick={onClose}>
    //       <i className="bi bi-x-lg"></i>
    //     </button>

    //     <div className="action-circle">
    //       <i className="bi bi-question-circle"></i>
    //     </div>

    //     <h3>Blog Action Required</h3>
    //     <p>What would you like to do with this blog?</p>
    //     <p><strong>{blogTitle || 'N/A'}</strong></p>

    //     <div className="modal-actions">
    //       <button className="btn-approve" onClick={onApprove}>
    //         Approve
    //       </button>
    //       <button className="btn-reject" onClick={onReject}>
    //         Reject
    //       </button>
    //     </div>
    //   </div>
    // </div>

    <div className="modal-overlay" id="modal">
      <div className="delete-modal">
        <div className="modal-close-icon" onClick={onClose}>
          <i className="bi bi-x-lg"></i>
        </div>
          <h2>Blog Action Required</h2>
          <p>What would you like to do with this blog?</p>
          <p className="reson-text">({blogTitle || "N/A"})</p> 
        {/* <button>OK</button> */}
        <div className="modal-actions">
          <button className="delete_approve_btn" onClick={onApprove}>
           Approve
          </button>
          <button className="delete_reject_btn" onClick={onReject}>
            Reject
          </button>
        </div>
      </div>
    </div>
  );
};

export default BlogActionModal;
